export default "__VITE_ASSET__1a8666cc__"